import { normalizeWorkspace } from '../../contracts/schemas.js'

export function createWorkspaceService(repository) {
  if (!repository) throw new Error('Workspace repository is required')
  let state = normalizeWorkspace(null)
  return {
    load() { const result = repository.load(); if (result.ok) state = result.value; return { ...result, value: state } },
    snapshot() { return JSON.parse(JSON.stringify(state)) },
    active() { return state.workspaces.find((workspace) => workspace.id === state.activeId) || state.workspaces[0] },
    replaceCanvas(canvas) {
      const activeId = state.activeId
      state = { ...state, workspaces: state.workspaces.map((workspace) => workspace.id === activeId ? { ...workspace, ...canvas } : workspace), rev: state.rev + 1 }
      return repository.save(state)
    },
    create(name = `工作台 ${state.workspaces.length + 1}`) {
      const workspace = { id: `ws_${Date.now()}`, name, nodes: [], edges: [], groups: [], schemaVersion: 1 }
      state = { ...state, workspaces: [...state.workspaces, workspace], activeId: workspace.id, rev: state.rev + 1 }
      repository.save(state)
      return workspace
    },
    activate(id) {
      if (!state.workspaces.some((workspace) => workspace.id === id)) return { ok: false, code: 'workspace.not-found' }
      state = { ...state, activeId: id, rev: state.rev + 1 }
      repository.save(state)
      return { ok: true, value: this.active() }
    },
  }
}
